import { Injectable } from '@angular/core';
import {
  VesselActivityListParams,
  VesselActivityPhasePayload,
} from '@app/domain';
import {
  VesselActivityElement,
  VesselActivityItem,
} from '@app/domain/entities/vessel-activity.entity';
import { VesselActivityRepository } from '@app/domain/repositories/vessel-activity.repository';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { Observable } from 'rxjs';
import { VesselActivityService } from '../api-clients/vessel-activity.service';

@Injectable()
export class VesselActivityRepositoryImpl implements VesselActivityRepository {
  constructor(private readonly _vesselActivityService: VesselActivityService) {}

  getList(
    params: VesselActivityListParams
  ): Observable<PaginatedResponse<VesselActivityItem>> {
    return this._vesselActivityService.listItems(params);
  }

  getClientCodes(): Observable<string[]> {
    return this._vesselActivityService.getClientCodes();
  }

  createPhase(
    body: VesselActivityPhasePayload
  ): Observable<VesselActivityItem> {
    return this._vesselActivityService.createPhase(body);
  }

  getDefaultInputFields(): Observable<VesselActivityElement[]> {
    return this._vesselActivityService.getDefaultInputFields();
  }

  getPhase(id: number): Observable<VesselActivityItem> {
    return this._vesselActivityService.getPhase(id);
  }

  updatePhase(
    id: number,
    body: VesselActivityPhasePayload
  ): Observable<VesselActivityItem> {
    return this._vesselActivityService.updatePhase(id, body);
  }

  getVisibility(): Observable<{
    isNomVisible: boolean;
    isPsVisible: boolean;
    clientCodes: string[];
  }> {
    return this._vesselActivityService.getVisibility();
  }

  updateVisibility(body: {
    shouldShowNom: boolean;
    shouldShowPS: boolean;
    clientCodes: string[];
  }): Observable<void> {
    return this._vesselActivityService.updateVisibility(body);
  }

  reorderItems(ids: number[]): Observable<void> {
    return this._vesselActivityService.reorderItems(ids);
  }

  toggleStatus(id: number): Observable<void> {
    return this._vesselActivityService.toggleStatus(id);
  }
}
